import images from '../assets/images';

const techData = [
    { id: 'flutter', title: 'Flutter', image: images.icons.flutterIcon },
    { id: 'dart', title: 'Dart', image: images.icons.dartIcon },
    { id: 'javascript', title: 'JavaScript', image: images.icons.javascriptIcon },
    { id: 'firebase', title: 'Firebase', image: images.icons.firebaseIcon },
    { id: 'react', title: 'React', image: images.icons.reactIcon },
    { id: 'bootstrap', title: 'Bootstrap', image: images.icons.bootstrapIcon },
    { id: 'node', title: 'Node.js', image: images.icons.nodeIcon },
    // { id: 'googleCloud', title: 'Google Cloud', image: images.icons.googleCloudIcon },
    { id: 'mySQL', title: 'MySQL', image: images.icons.mySQLIcon },
    // { id: 'photoshop', title: 'Photoshop', image: images.icons.photoshopIcon },
    // { id: 'xd', title: 'Adobe XD', image: images.icons.xdIcon },
    { id: 'neo4j', title: 'Neo4j', image: images.icons.neo4jIcon },
    { id: 'mongo', title: 'MongoDB', image: images.icons.mongoIcon },
    { id: 'figma', title: 'Figma', image: images.icons.figmaIcon },
    // { id: 'aftereffects', title: 'After Effects', image: images.icons.aftereffectsIcon },
    { id: 'anaconda', title: 'Anaconda', image: images.icons.anacondaIcon },
    { id: 'android', title: 'Android', image: images.icons.androidIcon },
    // { id: 'androidstudio', title: 'Android Studio', image: images.icons.androidstudioIcon },
    // { id: 'apple', title: 'Apple', image: images.icons.appleIcon },
    { id: 'apache', title: 'Apache', image: images.icons.apacheIcon },
    { id: 'arduino', title: 'Arduino', image: images.icons.arduinoIcon },
    // { id: 'atom', title: 'Atom', image: images.icons.atomIcon },
    // { id: 'azure', title: 'Azure', image: images.icons.azureIcon },
    // { id: 'babel', title: 'Babel', image: images.icons.babelIcon },
    // { id: 'behance', title: 'Behance', image: images.icons.behanceIcon },
    { id: 'c', title: 'C', image: images.icons.cIcon },
    { id: 'css3', title: 'CSS3', image: images.icons.css3Icon },
    // { id: 'digitalocean', title: 'DigitalOcean', image: images.icons.digitaloceanIcon },
    { id: 'elasticsearch', title: 'Elasticsearch', image: images.icons.elasticsearchIcon },
    { id: 'flask', title: 'Flask', image: images.icons.flaskIcon },
    { id: 'git', title: 'Git', image: images.icons.gitIcon },
    // { id: 'heroku', title: 'Heroku', image: images.icons.herokuIcon },
    { id: 'html5', title: 'HTML5', image: images.icons.html5Icon },
    { id: 'java', title: 'Java', image: images.icons.javaIcon },
    { id: 'npm', title: 'NPM', image: images.icons.npmIcon },
    { id: 'postman', title: 'Postman', image: images.icons.postmanIcon },
    { id: 'raspberrypi', title: 'Raspberry Pi', image: images.icons.raspberrypiIcon },
    { id: 'sass', title: 'Sass', image: images.icons.sassIcon },
    { id: 'tensorflow', title: 'TensorFlow', image: images.icons.tensorflowIcon },
    { id: 'typescript', title: 'TypeScript', image: images.icons.typescriptIcon },
    // { id: 'visualstudio', title: 'Visual Studio', image: images.icons.visualstudioIcon },
    // { id: 'vscode', title: 'VS Code', image: images.icons.vscodeIcon },
    { id: 'wordpress', title: 'WordPress', image: images.icons.wordpressIcon },
];
export default techData;
